module.exports = __webpack_public_path__ + "media/images/homepage-banner-52cc8a049d1d04e6e7bfdaae37370c4a.jpg";